export default "__VITE_ASSET__cb23907d__$_?component__"